import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const hh = Math.floor(seconds / 3600);
  const mm = Math.floor(seconds % 3600 / 60);
  const ss = seconds % 60;
  return {
    hh,
    mm,
    ss
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-31" data-mp="3h20hhbbf0lk2">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-white/10 bg-ink font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-32" data-mp="3gymf432r4ccm">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-33" data-mp="10c3crffr7dyu">{label}</span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 47);
  return <section aria-label="Cuenta regresiva" className="bg-ink" data-id="element-34" data-mp="xzbzlumvybm3">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center pt-[6px] pb-[0px]" data-id="element-35" data-mp="t2vb2zbrxv8h">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-rose-soft" data-id="element-36" data-mp="17rhp8xpo0gy4">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-37" data-mp="12seuq77b9t4e">
          <Unit value={hh} label="Horas" data-id="element-38" data-mp="f3dgu4fplprq" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-39" data-mp="f45f5n0oy1lp">:</span>
          <Unit value={mm} label="Min" data-id="element-40" data-mp="a5267rhlbb8g" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="o2qw5dqil8kd">:</span>
          <Unit value={ss} label="Seg" data-id="element-42" data-mp="k1f0orkylt49" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-43" data-mp="k0m4gkjmmm0d">
          ⚠️ Después sube $35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-44" data-mp="1zk08zhf512cp">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-45" data-mp="1vfiw82773pbf">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-46" data-mp="s7r5r62za35l">
            <div className="h-full w-[68%] rounded-full bg-rose" data-id="element-47" data-mp="x36ke08t8332" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-rose-soft" data-id="element-48" data-mp="1255nd90n0xzh">
            68% tomados — Quedan pocos
          </p>
        </div>
      </div>
    </section>;
}